if (!window.Eurus.loadedScript.includes('card-product-quantity.js')) {
    window.Eurus.loadedScript.push('card-product-quantity.js');

    /**
     * Đăng ký Alpine.js data function cho quantity buttons
     */
    function registerCardProductQuantity() {
        if (typeof Alpine === 'undefined' || !Alpine.data) {
            return false;
        }

        // Kiểm tra nếu đã đăng ký rồi thì không đăng ký lại
        if (Alpine.data('xCardProductQuantity')) {
            return true;
        }

        // Alpine.js data function cho quantity buttons trên product card
        Alpine.data('xCardProductQuantity', (variantId, initialInventory) => ({
            showQuantityButtons: false,
            variantId: variantId,
            initialInventory: initialInventory,

            /**
             * Lấy container div chứa các buttons
             * @returns {HTMLElement} Container div với class .group-button
             */
            getContainer() {
                if (this.$el.classList.contains('group-button')) {
                    return this.$el;
                }
                return this.$el.closest('.group-button') || this.$el;
            },

            /**
             * Lấy số lượng sản phẩm trong cart cho variant này
             * @returns {Promise<number>} Số lượng trong cart (0 nếu không có)
             */
            async getQuantityInCart() {
                try {
                    const response = await fetch('/cart.js');
                    const cart = await response.json();
                    const cartItem = cart.items.find(item => item.variant_id === this.variantId);
                    return cartItem ? cartItem.quantity : 0;
                } catch (error) {
                    console.error('[Get Cart Quantity] Error:', error);
                    return 0;
                }
            },

            /**
             * Cập nhật quantity attribute của buttons dựa trên số lượng trong cart
             */
            async updateQuantityFromCart() {
                const quantityInCart = await this.getQuantityInCart();
                const availableQuantity = Math.max(0, this.initialInventory - quantityInCart);

                const container = this.getContainer();
                const buttons = container.querySelectorAll('.add-quantity-button');

                buttons.forEach(button => {
                    button.setAttribute('quantity', availableQuantity);
                });

                this.updateButtonsState();
            },

            /**
             * Lấy số lượng cần thiết từ aria-label của button
             * @param {HTMLElement} button - Button element
             * @returns {number} Số lượng (1, 3, hoặc 6)
             */
            getButtonQuantity(button) {
                const ariaLabel = button.getAttribute('aria-label') || '';
                if (ariaLabel.includes('Add 1 to cart')) return 1;
                if (ariaLabel.includes('Add 3 to cart')) return 3;
                if (ariaLabel.includes('Add 6 to cart')) return 6;
                return 0;
            },

            /**
             * Cập nhật trạng thái disable và opacity của các buttons dựa trên quantity attribute
             */
            updateButtonsState() {
                const container = this.getContainer();
                const buttons = container.querySelectorAll('.add-quantity-button');

                if (buttons.length === 0) return;

                buttons.forEach(button => {
                    const currentQuantity = parseInt(button.getAttribute('quantity')) || 0;
                    const buttonQuantity = this.getButtonQuantity(button);

                    // Disable và thêm opacity nếu không đủ inventory
                    if (currentQuantity < buttonQuantity) {
                        button.disabled = true;
                        button.classList.add('opacity-50', 'cursor-not-allowed');
                    } else {
                        button.disabled = false;
                        button.classList.remove('opacity-50', 'cursor-not-allowed');
                    }
                });
            },

            /**
             * Thêm sản phẩm vào giỏ hàng với số lượng chỉ định
             * @param {number} quantity - Số lượng cần thêm vào giỏ hàng
             */
            addToCartWithQuantity(quantity) {
                this.showQuantityButtons = false;

                const container = this.getContainer();
                const cardProduct = container.closest(".card-product");
                const form = cardProduct?.querySelector("form[data-type=\"add-to-cart-form\"]");

                if (!form) return;

                // Lấy tất cả buttons từ container
                const quantityButtons = container.querySelectorAll('.add-quantity-button');
                if (quantityButtons.length === 0) return;

                // Lấy quantity hiện tại từ button đầu tiên
                const firstButton = quantityButtons[0];
                const currentQuantity = parseInt(firstButton.getAttribute('quantity')) || 0;

                // Tìm hoặc tạo quantity input trong form
                let quantityInput = form.querySelector("input[name=\"quantity\"]");
                if (!quantityInput) {
                    quantityInput = document.createElement("input");
                    quantityInput.type = "hidden";
                    quantityInput.name = "quantity";
                    quantityInput.value = "1";
                    form.appendChild(quantityInput);
                }

                quantityInput.value = quantity;

                // Tính toán quantity mới sau khi add to cart (optimistic update)
                const newQuantity = Math.max(0, currentQuantity - quantity);

                // Cập nhật ngay lập tức (optimistic update)
                quantityButtons.forEach(button => {
                    button.setAttribute('quantity', newQuantity);
                });
                this.updateButtonsState();

                // Click submit button để add to cart
                const submitButton = form.querySelector("button[type=\"submit\"][name=\"add\"]:not(.label-btn-quickview)");
                if (submitButton && !submitButton.disabled) {
                    submitButton.click();
                } else {
                    const iconButton = form.querySelector("button[type=\"submit\"][name=\"add\"].label-btn-quickview");
                    if (iconButton && !iconButton.disabled) {
                        iconButton.click();
                    }
                }
            },

            /**
             * Khởi tạo khi component được mount
             */
            init() {
                // Cập nhật quantity ban đầu từ cart
                this.updateQuantityFromCart();

                // Lắng nghe event khi cart được update (add, remove, change quantity)
                const handleCartUpdate = () => {
                    // delay để đảm bảo cart đã được update trên server
                    setTimeout(() => {
                        this.updateQuantityFromCart();
                    }, 300);
                };

                document.addEventListener("eurus:cart:items-changed", handleCartUpdate);
            }
        }));

        return true;
    }

    // register ngay nếu Alpine đã có sẵn
    if (typeof Alpine !== 'undefined' && Alpine.data) {
        registerCardProductQuantity();
    }

    // listen event alpine:init để register
    document.addEventListener('alpine:init', () => {
        registerCardProductQuantity();
    });
}

